import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  constructor() { }

  setCookie(name: string, value: string, years: number) {
    let expires = '';
    if (years) {
      const date = new Date();
      date.setFullYear(date.getFullYear() + years); // Set expiration for 100 years
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value}; path=/;${expires}; Secure; SameSite=Lax`;
  }

  getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? match[2] : null;
  }

  deleteCookie(name: string) {
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Lax`;
  }
}
